import { MarkGithubIcon } from "@primer/octicons-react";
import type { ImportProvider } from "../api/types";

/** How the provider with mode pr names its reviews, so batch texts read right. */
const FORGES = {
  github: {
    name: "GitHub",
    Icon: MarkGithubIcon,
    review: "pull request",
    Review: "Pull request",
    short: "PR",
    ref: (n: number) => `#${n}`,
    clean: "clean",
    tokenEnv: "BEE_GITHUB_TOKEN",
    tokenNeeds: "contents and pull requests write access",
  },
} as const;

export type Forge = (typeof FORGES)[ImportProvider];

export const forge = (_provider?: string | null): Forge => FORGES.github;
